import axios from 'axios'
import { API_GLOBAL_ENDPOINT } from '../constants'

// Get configuration from the global VNAPI
export const apiGetConfiguration = (org, env, scope, time) => {
  return axios.get(`${API_GLOBAL_ENDPOINT}/configurations/public?org=${org}&env=${env}&scope=${scope}&time=${time}`)
}
